const updates = [
  {
    id: 1,
    time: '刚刚',
    content: '某知名导演新片选角名单曝光，多位一线明星参与试镜竞争激烈，知情人士透露最终人选即将确定',
  },
  {
    id: 2,
    time: '15分钟前',
    content: '短视频平台上线新规限制带货内容频次，多位头部主播连夜调整直播策略应对变化',
  },
  {
    id: 3,
    time: '32分钟前',
    content: '某综艺节目未播片段意外流出，内容引发网友热议，节目组表示将追究泄露者法律责任',
  },
  {
    id: 4,
    time: '1小时前',
    content: '电竞联赛官方发布新赛季赛程调整公告，因场馆档期问题多场焦点对决时间变动',
  },
  {
    id: 5,
    time: '1.5小时前',
    content: '当红小花现身某品牌活动现场状态极佳，力破此前网络上的健康传闻谣言',
  },
  {
    id: 6,
    time: '2小时前',
    content: '某音乐平台年度榜单揭晓，独立音乐人异军突起占据多个前十席位引发行业关注',
  },
  {
    id: 7,
    time: '3小时前',
    content: '热播剧编剧回应争议剧情：后续将有重大反转，请观众耐心等待下周更新内容',
  },
  {
    id: 8,
    time: '4小时前',
    content: '知名博主曝光某餐饮品牌后厨卫生问题，涉事门店已被市场监管部门责令停业整顿',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            ⚡ 实时快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            滚动更新今日吃瓜最新动态，热门大瓜一手掌握
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updates.map((item, idx) => (
              <a
                key={item.id}
                href="#updates"
                className={`block relative pb-8 ${idx === updates.length - 1 ? 'pb-0' : ''} group cursor-pointer`}
              >
                <div className="absolute -left-[29px] top-0 w-[14px] h-[14px] rounded-full bg-primary-500 border-[2px] border-background-50 group-hover:scale-125 transition-transform"></div>

                <div className="bg-background-100 border border-background-200/70 rounded-xl p-4 group-hover:border-primary-200 transition-all duration-200">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-label font-medium whitespace-nowrap">
                      快讯
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed group-hover:text-foreground-800 transition-colors">
                    {item.content}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}